var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoldenVerticleStrip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16.02 67.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Golden_Beryl_2);}.cls-15,.cls-2{opacity:0.35;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#Golden_Beryl_2-2);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#Bronze_2);}.cls-19,.cls-20,.cls-21,.cls-29,.cls-30,.cls-6,.cls-7,.cls-8{opacity:0.59;}.cls-6{fill:url(#Bronze_2-2);}.cls-7{fill:url(#Bronze_2-3);}.cls-8{fill:url(#Bronze_2-4);}.cls-9{fill:#353739;}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill:url(#linear-gradient-4);}.cls-12{fill:url(#linear-gradient-5);}.cls-13,.cls-25,.cls-31{opacity:0.5;}.cls-13{fill:url(#linear-gradient-6);}.cls-14{fill:url(#Golden_Beryl_2-3);}.cls-15{fill:url(#linear-gradient-7);}.cls-16{fill:url(#linear-gradient-8);}.cls-17{fill:url(#linear-gradient-9);}.cls-18{fill:url(#Bronze_2-5);}.cls-19{fill:url(#Bronze_2-6);}.cls-20{fill:url(#Bronze_2-7);}.cls-21{fill:url(#Bronze_2-8);}.cls-22{fill:url(#linear-gradient-10);}.cls-23{fill:url(#linear-gradient-11);}.cls-24{fill:url(#linear-gradient-12);}.cls-25{fill:url(#linear-gradient-13);}.cls-26{fill:url(#Golden_Beryl_2-4);}.cls-27{fill:#eada91;}.cls-28{fill:url(#Bronze_2-9);}.cls-29{fill:url(#Bronze_2-10);}.cls-30{fill:url(#Bronze_2-11);}.cls-31{fill:url(#linear-gradient-14);}.cls-32{fill:url(#linear-gradient-15);}.cls-33{fill:url(#linear-gradient-16);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Golden_Beryl_2",
    x1: -1687.64,
    y1: 2001.07,
    x2: -1671.63,
    y2: 2001.07,
    gradientTransform: "matrix(1, 0, 0, -1, 1687.64, 2058.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbc766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f2f6de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#c6c9aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#a2a37f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#888860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#78774d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727146"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1672.23,
    y1: 2014.11,
    x2: -1672.23,
    y2: 1991.67,
    gradientTransform: "matrix(1, 0, 0, -1, 1687.64, 2058.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#3a381d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a381d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Golden_Beryl_2-2",
    x1: -1687.07,
    y1: 2005.64,
    x2: -1671.85,
    y2: 1990.42,
    xlinkHref: "#Golden_Beryl_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1686.97,
    y1: 2015.89,
    x2: -1686.97,
    y2: 2005.93,
    gradientTransform: "matrix(1, 0, 0, -1, 1687.64, 2058.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff7d4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff7d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2",
    x1: 2818.54,
    y1: -2506.37,
    x2: 2833.61,
    y2: -2506.37,
    gradientTransform: "translate(2514.34 2879.86) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#401617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6b4c2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#a48955"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e4d3b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#957858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#957858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#804f2e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-2",
    x1: -1685.04,
    y1: 2009.3,
    x2: -1684.01,
    y2: 2009.3,
    gradientTransform: "matrix(1, 0, 0, -1, 1687.64, 2058.04)",
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-3",
    x1: 1520.67,
    y1: -3031.64,
    x2: 1521.46,
    y2: -3031.64,
    gradientTransform: "matrix(-0.69, 0.72, 0.72, 0.69, 3251.72, 1048.1)",
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-4",
    x1: -1675.39,
    y1: 2004.25,
    x2: -1674.21,
    y2: 2004.25,
    gradientTransform: "matrix(1, 0, 0, -1, 1687.64, 2058.04)",
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -836.64,
    y1: 3127,
    x2: -836.64,
    y2: 3125.66,
    gradientTransform: "translate(3137.89 889.11) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#221f1f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2839.19,
    y1: -2508.36,
    x2: 2839.19,
    y2: -2509.7,
    gradientTransform: "translate(2513.41 2887.63) rotate(-90)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -1678.67,
    y1: 1953.42,
    x2: -1679.79,
    y2: 1952.3,
    gradientTransform: "matrix(1, 0, 0, -1, 1687.64, 2007.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#221f1f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#221f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2824.09,
    y1: -2500.95,
    x2: 2824.09,
    y2: -2499.55,
    gradientTransform: "translate(2514.34 2879.86) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eada91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eada91",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Golden_Beryl_2-3",
    x1: -1687.61,
    y1: -1640.91,
    x2: -1671.6,
    y2: -1640.91,
    gradientTransform: "translate(1687.61 1651.64)",
    xlinkHref: "#Golden_Beryl_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -1672.2,
    y1: -1627.3,
    x2: -1672.2,
    y2: -1648.73,
    gradientTransform: "translate(1687.61 1651.64)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -1687.04,
    y1: -1636.34,
    x2: -1671.82,
    y2: -1651.56,
    gradientTransform: "translate(1687.61 1651.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff7d4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff7d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -1686.94,
    y1: -1625.76,
    x2: -1686.94,
    y2: -1636.26,
    gradientTransform: "translate(1687.61 1651.64)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-5",
    x1: 2858.42,
    y1: -2506.37,
    x2: 2873.49,
    y2: -2506.37,
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-6",
    x1: -1685.06,
    y1: -1632.68,
    x2: -1683.87,
    y2: -1632.68,
    gradientTransform: "translate(1687.61 1651.64)",
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-7",
    x1: 4155.77,
    y1: -517.68,
    x2: 4156.58,
    y2: -517.68,
    gradientTransform: "translate(3251.73 2661.54) rotate(-133.65)",
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-8",
    x1: -1675.33,
    y1: -1637.73,
    x2: -1674.18,
    y2: -1637.73,
    gradientTransform: "translate(1687.61 1651.64)",
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2754.29,
    y1: 3127.04,
    x2: 2754.29,
    y2: 3125.66,
    gradientTransform: "matrix(0, -1, -1, 0, 3137.92, 2769.52)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -751.81,
    y1: -2508.3,
    x2: -751.81,
    y2: -2509.63,
    gradientTransform: "matrix(0, 1, 1, 0, 2513.38, 771.06)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -1678.51,
    y1: -1637.49,
    x2: -1679.73,
    y2: -1638.71,
    gradientTransform: "translate(1687.61 1651.64)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 721.08,
    y1: -2500.95,
    x2: 721.08,
    y2: -2499.55,
    gradientTransform: "matrix(0, 1, 1, 0, 2514.34, -709.15)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Golden_Beryl_2-4",
    x1: 2845.92,
    y1: -2514.34,
    x2: 2845.92,
    y2: -2498.33,
    gradientTransform: "translate(2514.34 2879.86) rotate(-90)",
    xlinkHref: "#Golden_Beryl_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-9",
    x1: 2858.59,
    y1: -2506.37,
    x2: 2833.24,
    y2: -2506.37,
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-10",
    x1: -1675.37,
    y1: 2024.08,
    x2: -1674.19,
    y2: 2024.08,
    gradientTransform: "matrix(1, 0, 0, -1, 1687.64, 2058.04)",
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-11",
    x1: -1685.08,
    y1: 2024.08,
    x2: -1683.97,
    y2: 2024.08,
    gradientTransform: "matrix(1, 0, 0, -1, 1687.64, 2058.04)",
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2845.93,
    y1: -2500.95,
    x2: 2845.93,
    y2: -2499.55,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 2853.69,
    y1: -2508.36,
    x2: 2853.69,
    y2: -2509.7,
    gradientTransform: "translate(2513.41 2887.63) rotate(-90)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2853.66,
    y1: 2860.34,
    x2: 2853.66,
    y2: 2858.96,
    gradientTransform: "matrix(0, -1, -1, 0, 2871.22, 2887.6)",
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WATER-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left_Frame",
    "data-name": "Left Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer_Frame",
    "data-name": "Outer Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base",
    className: "cls-1",
    d: "M0,46.25V53a.45.45,0,0,0,.14.33L15.26,67.57a.44.44,0,0,0,.75-.32v-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right_SD",
    "data-name": "Right SD",
    className: "cls-2",
    d: "M16,67a1.25,1.25,0,0,1,0,.5,1.42,1.42,0,0,1-.19.18l-1-2.32V46.25H16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Top_HL",
    "data-name": "Top HL",
    className: "cls-3",
    d: "M14.81,65.31,1.35,52.26,0,53s0,.21.07.26c.31.27.65.61.65.61L14.68,67a4.25,4.25,0,0,0,.66.6.39.39,0,0,0,.45,0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_HL",
    "data-name": "Left HL",
    className: "cls-4",
    points: "1.35 52.26 0 52.97 0 46.25 1.35 46.25 1.35 52.26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Frame",
    "data-name": "Inner Frame"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-2",
    "data-name": "Base",
    className: "cls-5",
    points: "2.52 46.25 2.54 51.23 13.41 61.32 13.41 46.25 2.52 46.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_SD",
    "data-name": "Left SD",
    className: "cls-6",
    points: "3.71 46.25 3.71 50.63 2.54 51.23 2.52 46.25 3.71 46.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top_SD",
    "data-name": "Top SD",
    className: "cls-7",
    points: "13.41 61.32 2.53 51.23 3.71 50.63 12.23 58.67 13.41 61.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Right_SD-2",
    "data-name": "Right SD",
    className: "cls-8",
    points: "12.23 46.25 12.23 58.67 13.41 61.32 13.41 46.25 12.27 46.25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base-3",
    "data-name": "Base"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "12.23 46.25 12.23 58.67 3.72 50.63 3.71 46.25 12.23 46.25"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Bottom",
    className: "cls-10",
    points: "10.89 55.57 10.89 46.25 12.23 46.25 12.23 58.67 10.89 55.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top",
    className: "cls-11",
    points: "5.05 46.25 5.05 49.84 3.71 50.63 3.71 46.25 5.05 46.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "12.23 58.67 3.71 50.63 5.05 49.84 10.89 55.57 12.23 58.67"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "14.81 65.31 13.41 61.27 13.41 46.26 14.81 46.25 14.81 65.31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Right_Frame",
    "data-name": "Right Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer_Frame-2",
    "data-name": "Outer Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base-4",
    "data-name": "Base",
    className: "cls-14",
    d: "M0,21.44V14.72a.43.43,0,0,1,.14-.32L15.26.12A.45.45,0,0,1,16,.45v21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right_SD-3",
    "data-name": "Right SD",
    className: "cls-15",
    d: "M16,.74a1.16,1.16,0,0,0,0-.49,1,1,0,0,0-.19-.18l-1,2.32V21.44H16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Top_HL-2",
    "data-name": "Top HL",
    className: "cls-16",
    d: "M14.81,2.39,1.34,15.44,0,14.72s0-.2.07-.26c.31-.27.65-.61.65-.61L14.68.67a4.25,4.25,0,0,1,.66-.6.39.39,0,0,1,.45,0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_HL-2",
    "data-name": "Left HL",
    className: "cls-17",
    points: "1.34 15.44 0 14.72 0 21.44 1.34 21.44 1.34 15.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Frame-2",
    "data-name": "Inner Frame"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-5",
    "data-name": "Base",
    className: "cls-18",
    points: "2.52 21.44 2.54 16.47 13.41 6.37 13.41 21.44 2.52 21.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_SD-2",
    "data-name": "Left SD",
    className: "cls-19",
    points: "2.52 21.44 2.54 16.47 3.74 17.07 3.74 21.44 2.52 21.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top_SD-2",
    "data-name": "Top SD",
    className: "cls-20",
    points: "13.41 6.37 2.53 16.47 3.73 17.07 12.26 9.02 13.41 6.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Right_SD-4",
    "data-name": "Right SD",
    className: "cls-21",
    points: "12.26 21.44 12.26 9.02 13.41 6.37 13.41 21.44 12.27 21.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-2",
    "data-name": "Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base-6",
    "data-name": "Base"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "12.26 21.44 12.26 9.02 3.75 17.07 3.74 21.44 12.26 21.44"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Bottom-2",
    "data-name": "Bottom",
    className: "cls-22",
    points: "10.9 12.35 10.88 21.44 12.26 21.44 12.26 9.02 10.9 12.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top-2",
    "data-name": "Top",
    className: "cls-23",
    points: "5.08 21.44 5.08 17.86 3.74 17.07 3.74 21.44 5.08 21.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-24",
    points: "12.26 9.02 3.74 17.07 5.08 17.86 10.9 12.35 12.26 9.02"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "14.81 2.4 13.41 6.43 13.41 21.43 14.81 21.44 14.81 2.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Center_Bars",
    "data-name": "Center Bars"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    y: 21.27,
    width: 16.01,
    height: 25.34
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Left_HL-3",
    "data-name": "Left HL",
    className: "cls-27",
    y: 21.27,
    width: 1.34,
    height: 25.33
  }), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Bars",
    "data-name": "Inner Bars"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M13.41,46.61V21.27m-10.89,0V46.62M13.41,21.27H12.26l0,17.46v7.89h1.18M3.74,21.27H2.52V46.62H3.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Right_SD-5",
    "data-name": "Right SD",
    className: "cls-29",
    points: "13.41 21.27 13.41 46.62 12.23 46.62 12.26 21.27 13.41 21.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Left_SD-3",
    "data-name": "Left SD",
    className: "cls-30",
    points: "3.74 21.27 3.71 46.62 2.52 46.62 2.52 21.27 3.74 21.27"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "14.81 46.61 13.41 46.62 13.41 21.27 14.81 21.27 14.81 46.61"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-3",
    "data-name": "Fill"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-7",
    "data-name": "Base",
    className: "cls-9",
    points: "12.26 21.27 3.74 21.27 3.71 46.62 12.23 46.62 12.26 21.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Left_SD-4",
    "data-name": "Left SD",
    className: "cls-32",
    points: "5.05 21.27 5.05 46.62 3.71 46.62 3.74 21.27 5.05 21.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Right_SD-6",
    "data-name": "Right SD",
    className: "cls-33",
    points: "10.88 21.27 10.88 46.62 12.23 46.62 12.26 21.27 10.88 21.27"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenVerticleStrip);
export default __webpack_public_path__ + "static/media/goldenVerticleStrip.5b7d8994cbf6b6b7c5d0561a3e92de75.svg";
export { ForwardRef as ReactComponent };